import { Component, computed } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

import { LocationWidget } from '../shared/location-widget';
import { CdkDrag, CdkDragDrop, CdkDropList, moveItemInArray } from '@angular/cdk/drag-drop';
import { WidgetLocation } from '../../../models/widget-location.model';
import { LocationTimeCardComponent } from './location-time-card/location-time-card.component';

@Component({
  selector: 'topo-time-cards-widget',
  imports: [TranslatePipe, LocationTimeCardComponent, CdkDropList, CdkDrag],
  templateUrl: './time-cards-widget.component.html',
  styleUrl: './time-cards-widget.component.scss'
})
export class TimeCardsWidgetComponent extends LocationWidget {
  protected locations = computed(() => {
    const locations = this.state.timesLocations();
    const { orderByLongitude } = this.state.timeCardSettings();
    return orderByLongitude ? locations.sort((a, b) => a?.focusPoint?.longitude - b?.focusPoint?.longitude) : locations;
  });

  protected cardWidth = computed(() => {
    const divider = this.locations().length;
    const amount = divider > 0 ? 100 / divider : 100;
    return `${amount}%`;
  });

  // used in edit mode
  setSelectedLocation(locationUId: string): void {
    this.selectedLocationUId.set(locationUId);
  }

  async setLocationFromMap(locationUId: string): Promise<void> {
    const newLocation = await this.getCurrentMapPositionAsWidgetLocation();

    if (!Boolean(newLocation)) {
      return;
    }

    const configuration = this.state.configuration();
    const times = [...configuration.times].map(l =>
      l.uId === locationUId
        ? {
            ...newLocation,
            uId: l.uId
          }
        : l
    );

    this.state.updateConfiguration({ ...configuration, times });
  }

  async addLocation(): Promise<void> {
    const newLocation = await this.getCurrentMapPositionAsWidgetLocation();

    if (!Boolean(newLocation)) {
      return;
    }

    const configuration = this.state.configuration();
    const times = [...configuration.times, newLocation];

    this.selectedLocationUId.set(newLocation.uId);
    this.state.updateConfiguration({ ...configuration, times });
  }

  removeLocation(locationUId: string): void {
    const configuration = this.state.configuration();
    const times = [...configuration.times].filter(l => l.uId !== locationUId);

    this.state.updateConfiguration({
      ...configuration,
      times
    });
  }

  changeLocationName(locationUId: string, name: string): void {
    const configuration = this.state.configuration();
    const locations = [...configuration.locations].map(l => (l.uId === locationUId ? { ...l, name } : l));

    this.state.updateConfiguration({
      ...configuration,
      locations
    });
  }

  drop(event: CdkDragDrop<WidgetLocation[]>) {
    const configuration = this.state.configuration();
    const locations = [...configuration.locations];

    moveItemInArray(locations, event.previousIndex, event.currentIndex);

    this.state.updateConfiguration({
      ...configuration,
      locations
    });
  }
}
